import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import FormatPrice from "../helper/FormatPrice";
import axios from "../helper/axios";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import "./FeaturedProducts.css";

const FeaturedProducts = () => {
  const [featureproducts, setFeatureProducts] = useState([]);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await axios.post(`product_read`, {
        category: ["jewelry"],
      });
      const featureProducts = response.data.data;
      // console.log('̥featureProducts', featureProducts);
      setFeatureProducts(featureProducts);
    } catch (error) {
      console.error(error.response.data);
      alert("Failed to fetch products.");
    }
  };

  return (
    <>
      <section className="light-section feature-product-section">
        <div className="container">
          <div className="section-subtitle">Check Now</div>
          <div className="section-title">Bestsellers</div>
          <Swiper
            // slidesPerView={4}
            spaceBetween={0}
            height={200}
            pagination={{
              clickable: true,
            }}
            modules={[Pagination]}
            breakpoints={{
              1500: {
                slidesPerView: 4,
              },
              1024: {
                slidesPerView: 3,
              },
              768: {
                slidesPerView: 2,
              },
              500: {
                slidesPerView: 1,
              },
            }}
            className="mySwiper mt-3rem"
          >
            {featureproducts?.map((curElem, index) => {
              return index < 7 ? (
                <SwiperSlide className="swiper-slide" key={index}>
                  <div className="cards__item">
                    <NavLink
                      to={`/singleproduct/${curElem.product_sku}`}
                      className="cards__item__link"
                    >
                      <figure
                        className="cards__item__pic-wrap"
                        data-category={curElem.product_type_name}
                      >
                        <img
                          className="cards__item__img"
                          alt="Diamond"
                          src={curElem.product_image[0]}
                        />
                      </figure>
                      <div className="cards__item__info">
                        <h5 className="cards__item__text">
                          <b>{curElem.product_name}</b>
                        </h5>
                        <span className="product-price">
                          <b></b>
                          {<FormatPrice price={curElem.product_price} />}
                        </span>

                        <div className="product-variations">
                          <div>
                            <span className="variation-title">
                              <b>Metal</b> :{" "}
                            </span>
                            <span className="variation-value">
                              {" "}
                              {curElem.metal_name}{" "}
                            </span>
                          </div>
                          <div>
                            <span className="variation-title">
                              <b>Carat</b> :{" "}
                            </span>
                            <span className="variation-value">
                              {" "}
                              {curElem.carat}K{" "}
                            </span>
                          </div>
                        </div>
                      </div>
                    </NavLink>
                  </div>
                </SwiperSlide>
              ) : null;
            })}
          </Swiper>
        </div>
      </section>
    </>
  );
};

export default FeaturedProducts;
